import { createSelector } from '@ngrx/store';

import { getRetentionState } from '../retention-feature.selector';

export const getConfirmationState = createSelector(
  getRetentionState,
  (state) => state.confirmation
);

export const getConfirmationFormState = createSelector(
  getConfirmationState,
  (state) => state.formState
);

export const getSmartChargingAddonSelected = createSelector(
  getConfirmationState,
  (state) => state.formState.value.smartChargingAddonAccepted
);

export const getSuccessPage = createSelector(
  getConfirmationState,
  (state) => state.successPage
);
